import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AlarmsManagerModel } from '../store/models/alarms-manager.model';
import { api } from '../consts/url.const';

@Injectable({
  providedIn: 'root',
})
export class AlarmsManagerService {
  constructor(private http: HttpClient) {}

  getAlarms(query?: AlarmsManagerModel.GetAlarmsQuery): Observable<AlarmsManagerModel.AlarmListResponse> {
    let params = new HttpParams();

    if (query?.page !== undefined) params = params.set('page', query.page.toString());
    if (query?.limit !== undefined) params = params.set('limit', query.limit.toString());
    if (query?.status !== undefined && query?.status !== null) params = params.set('status', query.status.toString());
    if (query?.locationId) params = params.set('locationId', query.locationId);
    if (query?.fromDate) params = params.set('fromDate', query.fromDate);
    if (query?.toDate) params = params.set('toDate', query.toDate);

    return this.http.get<AlarmsManagerModel.AlarmListResponse>(`${api.alarmsManager}/all`, { params });
  }

  getAlarmById(alarmId: number): Observable<AlarmsManagerModel.Alarm> {
    return this.http.get<AlarmsManagerModel.Alarm>(`${api.alarmsManager}/${alarmId}`);
  }

  getAlarmWithAlerts(alarmId: number): Observable<AlarmsManagerModel.AlarmWithAlerts> {
    return this.http.get<AlarmsManagerModel.AlarmWithAlerts>(`${api.alarmsManager}/${alarmId}/alerts`);
  }

  closeAlarm(alarmId: number, userId: string): Observable<{ success: boolean }> {
    const body: AlarmsManagerModel.CloseAlarmRequest = { userId };
    return this.http.put<{ success: boolean }>(`${api.alarmsManager}/${alarmId}/close`, body);
  }

  getAlarmStats(): Observable<AlarmsManagerModel.AlarmStatsResponse> {
    return this.http.get<AlarmsManagerModel.AlarmStatsResponse>(`${api.alarmsManager}/stats`);
  }

  checkTimeouts(): Observable<{ updatedCount: number }> {
    return this.http.post<{ updatedCount: number }>(`${api.alarmsManager}/check-timeouts`, {});
  }

  getAlarmAlertDetails(alarmId: number): Observable<AlarmsManagerModel.AlarmAlertDetails[]> {
    return this.http.get<AlarmsManagerModel.AlarmAlertDetails[]>(`${api.alarmsManager}/${alarmId}/alert-details`);
  }
}
